import Cash from "cash-dom";

const isLive = document.documentElement.classList.contains("-live");

function parseHtml(string) {
    let fragment = document.implementation.createHTMLDocument("");
    let base = fragment.createElement("base");
    base.href = document.location.href;
    fragment.head.appendChild(base);
    fragment.body.innerHTML = string.trim();

    return fragment.body.childNodes;
}

function getDefaultSettings(nummberOfSlides = 2) {
    return {
        //preloadImages: false,
        //lazyLoading: true,
        //lazyLoadingInPrevNext: true,
        //autoHeight: true,
        fade: {
            crossFade: true
        },
        spaceBetween: 30,
        simulateTouch: nummberOfSlides > 1 && isLive ? true : false,
        onlyExternal: nummberOfSlides > 1 && isLive ? false : true,
        onAutoplayStart: swiper => {
            Cash(swiper.container).addClass("swiper--autoplay");
        },
        onAutoplayStop: swiper => {
            Cash(swiper.container).removeClass("swiper--autoplay");
        },
        onInit: swiper => {
            let slider = swiper.container;
            let params = swiper.originalParams;
            params.init = true;
            setTimeout(function() {
                Cash(slider)
                    .data(params)
                    .addClass("swiper-init-true");
                setTimeout(function() {
                    Cash(slider).removeClass("-no-transition-delay");
                }, 1000);
            }, 10);
        }
    };
}

function flexSlides(slider, index = 0) {
    let css = "swiper-slides-flex-";
    let maxWidth = 0;
    let calcWidth = 0;
    Cash(slider).removeClass(`${css}1 ${css}auto`);
    let sliderWidth = Cash(slider).innerWidth();
    Cash(slider.swiper.slides).each(function() {
        let width = Cash(this).innerWidth();
        calcWidth += width;
        maxWidth = width > maxWidth ? width : maxWidth;
    });
    //console.log(sliderWidth, maxWidth, calcWidth, slider.swiper.slides.length);
    if (sliderWidth > slider.swiper.slides.length * maxWidth) {
        Cash(slider)
            .removeClass(css + "auto")
            .addClass(css + "1");
    } else if (sliderWidth > calcWidth) {
        Cash(slider)
            .removeClass(css + "1")
            .addClass(css + "auto");
    } else {
        Cash(slider)
            .removeClass(css + "auto")
            .removeClass(css + "1");
    }
}

function createNavigationButtons() {
    let nav = ["prev", "next"];
    let buttons = {};
    for (let i = 0; i < nav.length; i++) {
        buttons[nav[i]] = parseHtml(
            '<div class="swiper-button swiper-button-' +
                nav[i] +
                '"><svg class="icon icon-' +
                nav[i] +
                '"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-' +
                nav[i] +
                '"></use></svg></div>'
        )[0];
    }
    return buttons;
}

function writeNavigationButtons({ slider, insertAfter = false }) {
    Cash(slider)
        .parent()
        .find(".swiper-button-prev,.swiper-button-next")
        .remove();
    let buttons = createNavigationButtons();
    if (insertAfter) {
        Cash(buttons.prev)
            .add(buttons.next)
            .insertAfter(slider);
    } else {
        Cash(buttons.prev)
            .add(buttons.next)
            .appendTo(slider);
    }
    return buttons;
}

function writeMarkup({
    cssClass = false,
    extraClass = false,
    slider,
    insertAfter
}) {
    if (cssClass) {
        extraClass = extraClass ? " " + extraClass : "";
        let $markup = Cash(
            parseHtml(`<div class="${cssClass}${extraClass}"></div>`)
        );
        Cash(slider)
            .parent()
            .find(`.${cssClass}`)
            .remove();
        if (insertAfter) {
            $markup.insertAfter(slider);
        } else {
            $markup.appendTo(slider);
        }
        return $markup.get(0);
    }
    return false;
}

function writePagination({ slider, insertAfter = false, extraClass = false }) {
    let cssClass = "swiper-pagination";
    return writeMarkup({
        cssClass,
        extraClass,
        slider,
        insertAfter
    });
}

function randomizeOrder(elements) {
    let length = elements.length;
    elements.each(function() {
        let first = Math.floor(Math.random() * length - 1) + 1;
        let second = Math.floor(Math.random() * length - 1) + 1;
        elements.eq(first).before(elements.eq(second));
    });
}

function mergeSettings({ settings = {}, typeSettings = {}, nummberOfSlides }) {
    // Get default settings
    let options = getDefaultSettings(nummberOfSlides);
    // Overwrite options from typeSettings
    Cash.extend(options, typeSettings);
    // Overwrite options from settings
    Cash.extend(options, settings);
    // return options
    return options;
}

export {
    getDefaultSettings,
    createNavigationButtons,
    writeNavigationButtons,
    writeMarkup,
    writePagination,
    randomizeOrder,
    mergeSettings,
    flexSlides
};
